import React, { useState, useEffect } from 'react';
import {
  ActionBarGroupComp,
  DatatableGroups,
  CreateGroupComp,
  EditGroupComp,
  MapingGroupsComp,
  DetailGroupsComp,
} from '../../components';
import Modal from 'react-bootstrap/Modal';
import axios from '../../library/axios';
import { MySwal } from '../../library/swal';
import { useLocation } from 'react-router-dom';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { notifyApiLoadError } from '../../helpers/notifyApiError';

const GroupsPage = () => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const [search, setSearch] = useState([]);
  const [filterGroups, setFilterGroups] = useState([]);
  const [group, setGroup] = useState({});
  const [groups, setGroups] = useState([]);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);
  const [lgShowMaping, setLgShowMaping] = useState(false);
  const [lgShowDetail, setLgShowDetail] = useState(false);

  const [modules, setModules] = useState([]);
  // const [showAccessGroup, setshowAccessGroup] = useState(false);

  const fetchData = async () => {
    try {
      const options = {
        url: `/groups/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setGroups(data);
      setFilterGroups(data);
    } catch (err) {
      notifyApiLoadError(err, 'pages/groups/index.fetchData');
    }
  };

  const fetchModules = async () => {
    try {
      const options = {
        url: `/modules/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setModules([]);
      data.map((d) =>
        setModules((module) => [
          ...module,
          {
            label: d.namaModule,
            value: d.id,
          },
        ])
      );
      // console.log(data);
      // return false;
    } catch (err) {
      notifyApiLoadError(err, 'pages/groups/index.fetchModules');
    }
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname === mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/groups/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchData();
    fetchModules();
    fetchLoginStatus(); // eslint-disable-next-line
  }, []);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleEdit = (group) => {
    setGroup(group);
    setLgShowUpdate(true);
  };

  const handleMaping = (group) => {
    setGroup(group);
    setLgShowMaping(true);
  };

  const handleDetail = (group) => {
    setGroup(group);
    setLgShowDetail(true);
  };

  const handleShowModules = (group) => {
    // setshowAccessGroup(true)
    setGroup(group);
  };

  useEffect(() => {
    const result = groups.filter((item) => {
      let namaGroup = item.namaGroup;
      return namaGroup.toLowerCase().match(search.toString().toLowerCase());
    });
    setFilterGroups(result);
    // eslint-disable-next-line
  }, [search]);

  // console.log(modules);
  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Halaman Group
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            <ActionBarGroupComp showFormAdd={() => setLgShowAdd(true)} />
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <DatatableGroups
                      groups={filterGroups}
                      search={search}
                      handleChangeSearch={handleChangeSearch}
                      handleEdit={handleEdit}
                      handleMaping={handleMaping}
                      handleDetail={handleDetail}
                      showAccessGroup={handleShowModules}
                    />
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateGroupComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditGroupComp
            group={group}
            close={() => setLgShowUpdate(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowMaping}
        onHide={() => setLgShowMaping(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Maping Module</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MapingGroupsComp
            close={() => setLgShowMaping(false)}
            fetch={() => fetchData()}
            modules={modules}
            group={group}
          />
        </Modal.Body>
      </Modal>

      {/* Lihat Modules by Group */}
      <Modal
        show={lgShowDetail}
        onHide={() => setLgShowDetail(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>List {group?.namaGroup}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailGroupsComp
            close={() => setLgShowDetail(false)}
            group={group}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GroupsPage;
